import './HowItWorks.css';

function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="4" y="4" width="32" height="32" rx="4" stroke="#6C63FF" strokeWidth="2.5" />
          <path d="M4 14h32M14 4v32" stroke="#6C63FF" strokeWidth="2.5" />
        </svg>
      ),
      title: 'Choose a Template',
      description: 'Browse our collection of beautiful, professionally designed event templates. Pick one that matches your event style or start from scratch.',
    },
    {
      number: '02',
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M8 32c0-5.5 4.5-10 10-10h4c5.5 0 10 4.5 10 10" stroke="#6C63FF" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="20" cy="12" r="6" stroke="#6C63FF" strokeWidth="2.5" />
          <path d="M28 14h8M32 10v8" stroke="#6C63FF" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
      ),
      title: 'Add Event Details',
      description: 'Fill in your event information including date, time, location, and custom message. Add guests with their contact details.',
    },
    {
      number: '03',
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="4" y="6" width="32" height="24" rx="2" stroke="#6C63FF" strokeWidth="2.5" />
          <path d="M4 12l16 10 16-10" stroke="#6C63FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14 20l4 4 8-8" stroke="#6C63FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      title: 'Send Invitations',
      description: 'Share your event invitation via email, WhatsApp, or custom link. Track who received and opened their invitations in real-time.',
    },
    {
      number: '04',
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="6" y="8" width="28" height="24" rx="2" stroke="#6C63FF" strokeWidth="2.5" />
          <path d="M6 16h28" stroke="#6C63FF" strokeWidth="2.5" />
          <rect x="12" y="22" width="6" height="4" rx="1" fill="#6C63FF" />
          <rect x="22" y="22" width="6" height="4" rx="1" fill="#6C63FF" />
        </svg>
      ),
      title: 'Track RSVPs',
      description: 'Monitor responses as guests confirm or decline. Get instant notifications and manage your guest list with ease from your dashboard.',
    },
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <span className="how-it-works-tag">How It Works</span>
          <h2 className="how-it-works-title">
            Create Your Perfect Event in <span className="how-it-works-highlight">4 Simple Steps</span>
          </h2>
          <p className="how-it-works-subtitle">
            From invitation to celebration, AttendX makes event planning effortless. Get started in minutes and impress your guests.
          </p>
        </div>

        <div className="how-it-works-steps">
          {steps.map((step, index) => (
            <div key={index} className="how-it-works-step">
              <div className="how-it-works-step-number">{step.number}</div>
              <div className="how-it-works-step-icon">{step.icon}</div>
              <h3 className="how-it-works-step-title">{step.title}</h3>
              <p className="how-it-works-step-description">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="how-it-works-step-arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 5l7 7-7 7" stroke="#e5e7eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="how-it-works-cta">
          <p className="how-it-works-cta-text">Ready to create your first event?</p>
          <a href="/signup" className="how-it-works-cta-button">
            Get Started Free
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 3l5 5-5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
